import template from './fiscal-sales-analyser.html';
import controller from './fiscal-sales-analyser.controller';
import './fiscal-sales-analyser.scss';

let FiscalSalesAnalyserComponent = {
  bindings: {},
  template,
  controller
};

export default FiscalSalesAnalyserComponent;



// WEBPACK FOOTER //
// ./src/app/pages/fiscal-sales-analyser/fiscal-sales-analyser.component.js